/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
//import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
const Footer = (props) => {


  return (
    <div className="bg-gray-900 px-4 py-8 md:px-6">
      <div className="bg-gray-900">
        <div className="grid">
          <div className="col-12 md:col-3 flex flex-wrap justify-content-start md:mb-0 mb-3">
            <img
              src="/assets/logo/logo1_1_bianco.svg"
              alt="footer sections"
              width={200}
              height={200}
              className="mr-3"
            />
            <div className="text-gray-300 font-bold text-5xl"></div>
          </div>
          <div className="col-12 md:col-3">
            <div
              className="text-white text-lg mb-4 flex flex-wrap"
              style={{ maxWidth: " 290px" }}
            >
              Via Europa, 20, 20005 Pogliano Milanese MI
            </div>
            <div className="text-white mb-3">
              <a className="pi pi-phone border-round p-1 mr-2 text-white" onClick={()=>window.open("https://wa.me/393284874103", "_blank")}> (+39) 3284874103</a>
              
            </div>
            <div className="text-white mb-3">
              <i className="pi pi-inbox border-round p-1 mr-2"></i>
              P.IVA: 13680540963
            </div>
          </div>
          <div className="col-12 md:col-3 text-gray-200">
            <div className="text-white font-bold line-height-3 mb-3">
              Ristrutturazioni
            </div>
            <u>
            
            <a  onClick={() => props.openPreventivo("casaindipendente")}  className="text-white line-height-3 block cursor-pointer underlined mb-2">
              Casa indipendente
            </a>
            </u>
            <u>
            <a  onClick={() => props.openPreventivo("appartamento")}  className="text-white line-height-3 block cursor-pointer underlined mb-2">
              Appartamento
            </a>
            </u>
           
            <Link to="/bagno"
                  className="text-white line-height-3 block cursor-pointer py-1"
            >Bagno</Link>
            <Link to="/cucina"
                  className="text-white line-height-3 block cursor-pointer"
            >Cucina</Link>
          </div>
          <div className="col-12 md:col-3 text-gray-200">
            <div className="text-white font-bold line-height-3 mb-3">
              Azienda
            </div>
            <Link to="/chisiamo"
                  className="text-white line-height-3 block cursor-pointer"
            >Chi siamo</Link>
            
            <Link to="/portfolio"
                  className="text-white line-height-3 block py-1 cursor-pointer"
            >Portfolio</Link>
           
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
